import React, { useState, useEffect } from 'react';

const RandaLandsSite = () => {
  const [currentPage, setCurrentPage] = useState('home');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  const Nav = () => (
    <nav className="bg-white shadow-sm py-4 px-8 flex justify-between items-center sticky top-0 z-50">
      <div className="text-2xl font-bold text-sky-700 cursor-pointer" onClick={() => setCurrentPage('home')}>
        Randa Lands LLC
      </div>
      <div className="hidden md:flex space-x-8 font-medium text-slate-600">
        <button onClick={() => setCurrentPage('home')} className="hover:text-sky-600 transition">Home</button>
        <button onClick={() => {setCurrentPage('home'); setTimeout(() => document.getElementById('services')?.scrollIntoView({behavior: 'smooth'}), 100)}} className="hover:text-sky-600 transition">Services</button>
        <button onClick={() => {setCurrentPage('home'); setTimeout(() => document.getElementById('contact')?.scrollIntoView({behavior: 'smooth'}), 100)}} className="hover:text-sky-600 transition">Contact</button>
      </div>
    </nav>
  );

  const Footer = () => (
    <footer className="py-12 bg-slate-50 px-8 text-center text-sm text-slate-500 border-t border-slate-200">
      <div className="max-w-6xl mx-auto">
        <p className="mb-4 font-medium text-slate-700">© 2026 Randa Lands LLC. Registered in Wyoming. All Rights Reserved.</p>
        <div className="flex flex-wrap justify-center gap-6">
          <button onClick={() => setCurrentPage('privacy')} className="hover:text-sky-600 transition underline text-sky-700">Privacy Policy</button>
          <button onClick={() => setCurrentPage('refund')} className="hover:text-sky-600 transition underline text-sky-700">Refund Policy</button>
          <button onClick={() => setCurrentPage('terms')} className="hover:text-sky-600 transition underline text-sky-700">Terms of Service</button>
        </div>
      </div>
    </footer>
  );

  const HomePage = () => (
    <div className="animate-fadeIn">
      <header className="py-24 px-8 text-center bg-gradient-to-b from-sky-200 to-sky-50 border-b border-sky-100">
        <h1 className="text-4xl md:text-6xl font-extrabold text-slate-900 mb-6 tracking-tight">
          Strategic Real Estate Consulting <br className="hidden md:block"/> & Land Management Services
        </h1>
        <p className="text-lg md:text-xl text-slate-600 max-w-3xl mx-auto mb-10 leading-relaxed font-light">
          Professional due diligence, market analysis, and administrative support for US land acquisitions. Based in Wyoming.
        </p>
        <button onClick={() => document.getElementById('contact')?.scrollIntoView({behavior: 'smooth'})} className="bg-sky-600 text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-sky-700 transition shadow-xl">
          Book a Consultation
        </button>
      </header>
      <section id="services" className="py-24 px-8 max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-16 text-slate-900">Consulting Expertise</h2>
        <div className="grid md:grid-cols-3 gap-10">
          {[
            { title: "Due Diligence", desc: "Verification of property titles and legal standing to ensure secure transactions." },
            { title: "Market Research", desc: "Analysis of land density, zoning laws, and regional market trends in the US." },
            { title: "Closing Coordination", desc: "Administrative support for deed preparation and electronic recording compliance." }
          ].map((service, i) => (
            <div key={i} className="bg-white p-10 rounded-2xl shadow-sm border border-sky-100 hover:border-sky-300 transition-colors">
              <h3 className="text-xl font-bold mb-4 text-sky-900">{service.title}</h3>
              <p className="text-slate-600 leading-relaxed font-light">{service.desc}</p>
            </div>
          ))}
        </div>
      </section>
      <section id="contact" className="py-24 px-8 bg-slate-900 text-white text-center md:text-left">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16">
          <div className="space-y-6">
            <h2 className="text-3xl font-bold text-sky-400">Contact Information</h2>
            <p className="text-slate-300"><strong>Entity:</strong> Randa Lands LLC</p>
            <p className="text-slate-300"><strong>Address:</strong> Randa Lands #90102, 5830 East 2nd St. PMB 90102, Casper, WY 82609</p>
            <p className="text-slate-300"><strong>Phone:</strong> (307) 218-2259</p>
            <p className="text-slate-300">
  <strong>Email:</strong> <a href="mailto:randalands.us@gmail.com" className="hover:text-sky-400 transition underline">randalands.us@gmail.com</a>
</p>
          </div>
          <div className="bg-white p-10 rounded-3xl text-slate-800 shadow-2xl border-t-8 border-sky-500">
            <h3 className="text-2xl font-bold mb-4 text-center">Service Portal</h3>
            <p className="text-slate-500 mb-8 text-center text-sm">Use our secure gateway for consulting or document fees.</p>
            <a href="https://buy.stripe.com/aFaaEYcXc6Ujf9V9582cg01" className="block w-full text-center bg-sky-600 text-white py-4 rounded-xl font-bold text-lg hover:bg-sky-700 transition">Secure Payment Gateway</a>
          </div>
        </div>
      </section>
    </div>
  );

  const PrivacyPage = () => (
    <div className="max-w-4xl mx-auto py-20 px-8 leading-relaxed">
      <h1 className="text-4xl font-bold mb-8 text-slate-900 border-b pb-4">Privacy Policy</h1>
      <p className="mb-8 text-slate-500 italic text-sm">Last Updated: March 2026</p>
      <div className="space-y-6 text-slate-700 font-light">
        <h2 className="text-2xl font-bold text-sky-800">1. Information We Collect</h2>
        <p>We collect personal information that you voluntarily provide to us when expressing interest in our services.</p>
        <h2 className="text-2xl font-bold text-sky-800">2. Data Security</h2>
        <p>Your payment data is handled by 256-bit encrypted third-party gateways (Stripe/Mercury).</p>
      </div>
    </div>
  );

  const RefundPage = () => (
    <div className="max-w-4xl mx-auto py-20 px-8 leading-relaxed">
      <h1 className="text-4xl font-bold mb-8 text-slate-900 border-b pb-4">Refund Policy</h1>
      <div className="space-y-6 text-slate-700 font-light">
        <h2 className="text-2xl font-bold text-sky-800">1. Consulting Services</h2>
        <p>Once professional research or administrative work has been initiated, fees are non-refundable.</p>
        <h2 className="text-2xl font-bold text-sky-800">2. Deposits</h2>
        <p>Reservation deposits are non-refundable as they involve document preparation costs.</p>
      </div>
    </div>
  );

  const TermsPage = () => (
    <div className="max-w-4xl mx-auto py-20 px-8 leading-relaxed">
      <h1 className="text-4xl font-bold mb-8 text-slate-900 border-b pb-4">Terms of Service</h1>
      <div className="space-y-6 text-slate-700 font-light">
        <h2 className="text-2xl font-bold text-sky-800">1. Scope</h2>
        <p>Randa Lands LLC provides real estate consulting and coordination. We are not a law firm or a licensed financial advisory.</p>
        <h2 className="text-2xl font-bold text-sky-800">2. Governing Law</h2>
        <p>Any disputes shall be governed by the laws of the State of Wyoming, USA.</p>
      </div>
    </div>
  );

  const renderContent = () => {
    switch(currentPage) {
      case 'privacy': return <PrivacyPage />;
      case 'refund': return <RefundPage />;
      case 'terms': return <TermsPage />;
      default: return <HomePage />;
    }
  };

  return (
    <div className="min-h-screen bg-sky-50 font-sans selection:bg-sky-200">
      <Nav />
      {renderContent()}
      <Footer />
    </div>
  );
};

export default RandaLandsSite;